import React from 'react';

const deal = () => (
    <div className={`u-width32 u-height12 u-flex justify-content-center align-items-center u-borderRadius4 u-backgroundColorGreenDark`}>
        <span className={`u-fontWeightMedium u-textColorWhite u-fontSize09`}>DEAL</span>
    </div>
);

export default deal;


// WEBPACK FOOTER //
// ./src/components/UI/Deal/Deal.js